export default "__VITE_ASSET__Bl4HKEGL__"